export default __webpack_public_path__ + "static/media/cyberpunk-jacket1.5318a12d.jpg";